import { render, staticRenderFns } from "./CustomFormTextAreaElement.vue?vue&type=template&id=3cb67240"
import script from "./CustomFormTextAreaElement.vue?vue&type=script&lang=js"
export * from "./CustomFormTextAreaElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports